import Vue from 'vue';
import mutations from './ads.mutationlist';

/* eslint no-param-reassign: [
  "error", { "props": true, "ignorePropertyModificationsFor": ["state"] }
] */
export default {
  [mutations.MASONRY_GRID](state, payload) {
    Vue.set(state, 'grid_columns', payload);
  },
  [mutations.SET_ADS](state, payload) {
    Vue.set(state, 'records', payload);
  },
  [mutations.UPDATE_AD](state, payload) {
    Vue.set(state, 'records', state.records
      .map(item => (Number(item.id) === Number(payload.id) ? payload : item)));
  },
};



// WEBPACK FOOTER //
// ./src/store/ads/ads.mutations.js